import { Browser } from '@capacitor/browser';
import { AuthConfig } from 'angular-oauth2-oidc';

export const baseWebAuthConfig: AuthConfig = {
  responseType: 'code',
  scope: 'openid profile email offline_access',
  clearHashAfterLogin: false,
  sessionChecksEnabled: false,
} as AuthConfig;

export const baseIosAuthConfig = {
  responseType: 'code',
  scope: 'openid profile email offline_access',
  clearHashAfterLogin: false,
  sessionChecksEnabled: false,
  openUri: uri => {
    Browser.open({ url: uri, presentationStyle: 'popover' }).then();
  },
} as AuthConfig;

export const baseAndroidAuthConfig = {
  responseType: 'code',
  scope: 'openid profile email offline_access',
  clearHashAfterLogin: false,
  sessionChecksEnabled: false,
  openUri: uri => {
    Browser.open({ url: uri }).then();
  },
} as AuthConfig;
